module.exports = __webpack_public_path__ + "media/packs/site/assets/images/cart/empty-de942b3bb76ecab016e4f454cb8af81f.png";